import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { SingleUserSelect as SingleUserSelectWidget } from "widgets/singleuserselect";
import { DROPDOWN_TYPE } from "widgets/inputs";

import { Base } from "../base";
import { SingleUser as SingleUserReadOnly } from "../../renderers/singleuser";

export function SingleUserSelect(props) {
  const { column, value, pos, row } = props;
  const baseRef = useRef(null);
  const selectRef = useRef(null);
  const [currentValue, setCurrentValue] = useState(value);
  const [dataSource, setDataSource] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(
    function updateValue() {
      setCurrentValue(value || null);
      setIsOpen(false);
      // selectRef.current && selectRef.current.blur();
      // setDataSource([]);
    },
    [value, row, pos]
  );

  return (
    <Base {...props} ref={baseRef} onEditing={(e) => {}} type="user">
      {column.readOnly && <SingleUserReadOnly value={value} column={column} />}
      {!column.readOnly && (
        <SingleUserSelectWidget
          value={currentValue}
          dataSource={dataSource}
          isOpen={isOpen}
          ref={selectRef}
          onOpen={() => {
            setIsLoading(true);
            baseRef.current.startEditing(currentValue);
            column.dataSource &&
              column.dataSource({ value, row }).then((dataSource) => {
                setDataSource(dataSource && (dataSource.Data || dataSource));
                selectRef.current.focus();
                setIsOpen(true);
                setIsLoading(false);
              });
          }}
          onChange={(user) => {
            selectRef.current && selectRef.current.blur();
            setTimeout(() => {
              selectRef.current && selectRef.current.focus();
              baseRef.current.startEditing(currentValue);
              baseRef.current.dataChanged(user === undefined ? null : user);
              baseRef.current.dataCompleted();
              setDataSource([]);
            }, 100);
          }}
          onSearch={({ search }) =>
            column.onSearch({ search, value: currentValue, row, column })
          }
          type={DROPDOWN_TYPE.MINIMAL}
          checkDataSourceForValue={false}
          isLoading={isLoading}
        />
      )}
    </Base>
  );
}

SingleUserSelect.propTypes = {
  value: PropTypes.any,
  column: PropTypes.any,
  pos: PropTypes.any,
  row: PropTypes.any
};
